import { applyMiddleware, legacy_createStore as createStore, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import history from 'Utility/history';
import { allSagas, injectSaga } from 'Store/sagas';
import loggerMiddleware from './middleware/logger';
import globals from './middleware/globals';
import monitorReducerEnhancer from './enhancers/monitorReducers';
import createReducer from './reducers';

const immutableStateInvariantMiddleware = require('redux-immutable-state-invariant').default();

const composeEnhancers = composeWithDevTools({
	trace: true,
	traceLimit: 25,
	serialize: {
		options: {
			undefined: true,
			function(fn) {
				return fn.toString();
			},
		},
	},
});
const sagaMiddleware = createSagaMiddleware();

const rootStore = (initialState = {}) => {
	// ======================================================
	// Middleware Configuration
	// ======================================================

	const middlewares = [sagaMiddleware, thunkMiddleware, routerMiddleware(history), globals];
	if (process.env.NODE_ENV !== 'production' && process.env.DEBUG_MODE) {
		middlewares.push(immutableStateInvariantMiddleware, loggerMiddleware);
	}

	// ======================================================
	// Store Enhancers
	// ======================================================
	const enhancers = [applyMiddleware(...middlewares)];
	if (!process.env.DEBUG_MODE) {
		enhancers.push(monitorReducerEnhancer);
	}

	// ======================================================
	// Store Instantiation and HMR Setup
	// ======================================================
	const store = createStore(
		createReducer(),
		initialState,
		process.env.NODE_ENV === 'development' ? composeEnhancers(...enhancers) : compose(...enhancers)
	);

	store.asyncReducers = {};
	store.injectedSagas = new Map();

	if (module.hot) {
		module.hot.accept('./reducers', () => {
			store.replaceReducer(createReducer(store.asyncReducers));
		});
	}
	store.runSaga = sagaMiddleware.run;
	allSagas.forEach((sagas) => {
		injectSaga(store, { key: sagas.key, asyncSaga: sagas.value }, {});
	});

	return store;
};

export default rootStore();
